export enum ActivityLogOperationTypeEnum {
  // Create Operations
  CreateFile = 'CreateFile', // Creating a new file
  CreateFolder = 'CreateFolder', // Creating a new folder
  CreateFileFailed = 'CreateFileFailed', // Failed attempt to create a new file
  CreateFolderFailed = 'CreateFolderFailed', // Failed attempt to create a new folder

  // Read Operations
  ReadFile = 'ReadFile', // Reading a file
  ReadFolder = 'ReadFolder', // Reading a folder
  DownloadFile = 'DownloadFile', // Downloading a file
  DownloadFileEncrypted = 'DownloadFileEncrypted', // Downloading a file in encrypted form
  DownloadFileZip = 'DownloadFileZip', // Downloading a file compressed in Zip mode
  SearchFiles = 'SearchFiles', // Searching Files
  ReadFileFailed = 'ReadFileFailed', // Failed attempt to read a file
  ReadFolderFailed = 'ReadFolderFailed', // Failed attempt to read a folder
  DownloadFileFailed = 'DownloadFileFailed', // Failed attempt to download a file
  DownloadFileEncFailed = 'DownloadFileEncFailed', // Failed attempt to download a encrypted file
  DownloadFileZipFailed = 'DownloadFileZipFailed', // Failed attempt to download a zip file

  // Update Operations
  UpdateFile = 'UpdateFile', // Updating an existing file
  RenameFile = 'RenameFile', // Renaming a file
  MoveFile = 'MoveFile', // Moving a file to a different location
  DuplicateFile = 'DuplicateFile', // Copying a file
  UploadFile = 'UploadFile', // Upload new file
  UpdateFileFailed = 'UpdateFileFailed', // Failed attempt to update a file
  RenameFileFailed = 'RenameFileFailed', // Failed attempt to rename a file
  MoveFileFailed = 'MoveFileFailed', // Failed attempt to move a file
  DuplicateFileFailed = 'DuplicateFileFailed', // Failed attempt to copy a file
  UploadFileFailed = 'UploadFileFailed', // Failed attempt to upload a file

  // Delete Operations
  DeleteFileToRecycleBin = 'DeleteFileToRecycleBin', // Deleting a file to the recycle bin
  DeleteFolderToRecycleBin = 'DeleteFolderToRecycleBin', // Deleting a folder to the recycle bin
  DeleteFileToRecycleBinFailed = 'DeleteFileToRecycleBinFailed', // Failed attempt to delete a file to the recycle bin
  DeleteFolderToRecycleBinFailed = 'DeleteFolderToRecycleBinFailed', // Failed attempt to delete a folder to the recycle bin

  // Permanent Deletions
  DeleteFilePermanently = 'DeleteFilePermanently', // Permanently deleting a file
  DeleteFolderPermanently = 'DeleteFolderPermanently', // Permanently deleting a folder
  DeleteFilePermanentlyFailed = 'DeleteFilePermanentlyFailed', // Failed attempt to permanently delete a file
  DeleteFolderPermanentlyFailed = 'DeleteFolderPermanentlyFailed', // Failed attempt to permanently delete a folder

  // Share Operations
  ShareFile = 'ShareFile', // Sharing a file
  ShareFolder = 'ShareFolder', // Sharing a folder
  RevokeShare = 'RevokeShare', // Revoking a share
  ShareFileFailed = 'ShareFileFailed', // Failed attempt to share a file
  ShareFolderFailed = 'ShareFolderFailed', // Failed attempt to share a folder
  RevokeShareFailed = 'RevokeShareFailed', // Failed attempt to revoke a share

  // Audit
  ViewAuditLog = 'ViewAuditLog', // Viewing the audit log
  ExportAuditLog = 'ExportAuditLog', // Exporting the audit log
  ViewAuditLogFailed = 'ViewAuditLogFailed', // Failed attempt to view the audit log
  ExportAuditLogFailed = 'ExportAuditLogFailed', // Failed attempt to export the audit log

  // Access Control Operations
  GrantAccess = 'GrantAccess', // Granting access to a user or group
  RevokeAccess = 'RevokeAccess', // Revoking access from a user or group
  GrantAccessFailed = 'GrantAccessFailed', // Failed attempt to grant access
  RevokeAccessFailed = 'RevokeAccessFailed', // Failed attempt to revoke access

  // Versioning Operations
  CreateVersion = 'CreateVersion', // Creating a new version of a file
  RevertVersion = 'RevertVersion', // Reverting to a previous version of a file
  CreateVersionFailed = 'CreateVersionFailed', // Failed attempt to create a new version
  RevertVersionFailed = 'RevertVersionFailed', // Failed attempt to revert to a previous version

  // Collaboration Operations
  CommentFile = 'CommentFile', // Commenting on a file
  ReplyComment = 'ReplyComment', // Replying to a comment on a file
  AssignTask = 'AssignTask', // Assigning a task related to a file
  CommentFileFailed = 'CommentFileFailed', // Failed attempt to comment on a file
  ReplyCommentFailed = 'ReplyCommentFailed', // Failed attempt to reply to a comment
  AssignTaskFailed = 'AssignTaskFailed', // Failed attempt to assign a task

  // Miscellaneous Operations
  PreviewFile = 'PreviewFile', // Previewing a file
  HiddenFile = 'HiddenFile', // Hidden a file
  UnhiddenFile = 'UnhiddenFile', // Unhidden a file
  AddToFavorites = 'AddToFavorites', // Adding a file to favorites
  RemoveFromFavorites = 'RemoveFromFavorites', // Removing a file from favorites
  PreviewFileFailed = 'PreviewFileFailed', // Failed attempt to preview a file
  HiddenFileFailed = 'HiddenFileFailed', // Failed attempt to hidden a file
  UnhiddenFileFailed = 'UnhiddenFileFailed', // Failed attempt to unhidden a file
  AddToFavoritesFailed = 'AddToFavoritesFailed', // Failed attempt to add to favorites
  RemoveFromFavoritesFailed = 'RemoveFromFavoritesFailed', // Failed attempt to remove from favorites

  // Admin Operations
  CreateUser = 'CreateUser', // Creating a new user
  EditUser = 'EditUser', // Editing an existing user
  RemoveUser = 'RemoveUser', // Removing a user
  CreateGroup = 'CreateGroup', // Creating a new group
  EditGroup = 'EditGroup', // Editing an existing group
  RemoveGroup = 'RemoveGroup', // Removing a group
  OnBehalfOfAccess = 'OnBehalfOfAccess', // Accessing on behalf of another user
  OnBehalfOfOperation = 'OnBehalfOfOperation', // Operating on behalf of another user
  CreateUserFailed = 'CreateUserFailed', // Failed attempt to create a user
  EditUserFailed = 'EditUserFailed', // Failed attempt to edit a user
  RemoveUserFailed = 'RemoveUserFailed', // Failed attempt to remove a user
  CreateGroupFailed = 'CreateGroupFailed', // Failed attempt to create a group
  EditGroupFailed = 'EditGroupFailed', // Failed attempt to edit a group
  RemoveGroupFailed = 'RemoveGroupFailed', // Failed attempt to remove a group
  OnBehalfOfAccessFailed = 'OnBehalfOfAccessFailed', // Failed attempt to access on behalf of another user
  OnBehalfOfOperationFailed = 'OnBehalfOfOperationFailed', // Failed Operating on behalf of another user

  // Members Access
  LogIn = 'LogIn', // Logging in
  LogOut = 'LogOut', // Logging out
  OTPRequest = 'OTPRequest', // OTP Request
  LogInFailed = 'LogInFailed', // Failed attempt to log in
  LogOutFailed = 'LogOutFailed', // Failed attempt to log out
  OTPRequestFailed = 'OTPRequestFailed', // Failed attempt to otp request

  // Tags Operations
  AddTag = 'AddTag', // Adding a tag to a file
  RemoveTag = 'RemoveTag', // Removing a tag from a file
  UpdateTag = 'UpdateTag', // Updating a tag on a file
  ListTags = 'ListTags', // Listing all tags for a file
  AddTagFailed = 'AddTagFailed', // Failed attempt to add a tag to a file
  RemoveTagFailed = 'RemoveTagFailed', // Failed attempt to remove a tag from a file
  UpdateTagFailed = 'UpdateTagFailed', // Failed attempt to update a tag on a file
  ListTagsFailed = 'ListTagsFailed', // Failed attempt to list all tags for a file

  // Additional Operations
  RestoreFile = 'RestoreFile', // Restoring a deleted file
  MergeFiles = 'MergeFiles', // Merging multiple files into one
  SplitFile = 'SplitFile', // Splitting a file into multiple parts
  LockFile = 'LockFile', // Locking a file from changes
  UnlockFile = 'UnlockFile', // Unlocking a file
  Synchronize = 'Synchronize', // Synchronizing files or folders
  TagFile = 'TagFile', // Adding tags to a file
  RemoveTagFile = 'RemoveTagFile', // Removing tags from a file
  EncryptFile = 'EncryptFile', // Encrypting a file
  DecryptFile = 'DecryptFile', // Decrypting a file
  ChangeFileOwner = 'ChangeFileOwner', // Changing the owner of a file
  SetFileExpiration = 'SetFileExpiration', // Setting an expiration date for a file
  GenerateShareLink = 'GenerateShareLink', // Generating a share link
  ValidateUser = 'ValidateUser', // Validating a user (e.g., for 2FA)
  SignFile = 'SignFile', // Sign a file with digital signature
  FileDescription = 'FileDescription', // Setting file Description
  ShortCut = 'ShortCut', // Generation a file shortcut

  RestoreFileFailed = 'RestoreFileFailed', // Failed attempt to restore a file
  MergeFilesFailed = 'MergeFilesFailed', // Failed attempt to merge files
  SplitFileFailed = 'SplitFileFailed', // Failed attempt to split a file
  LockFileFailed = 'LockFileFailed', // Failed attempt to lock a file
  UnlockFileFailed = 'UnlockFileFailed', // Failed attempt to unlock a file
  SynchronizeFailed = 'SynchronizeFailed', // Failed attempt to synchronize files
  TagFileFailed = 'TagFileFailed', // Failed attempt to add tags to a file
  RemoveTagFileFailed = 'RemoveTagFileFailed', // Failed attempt to remove tags from a file
  EncryptFileFailed = 'EncryptFileFailed', // Failed attempt to encrypt a file
  DecryptFileFailed = 'DecryptFileFailed', // Failed attempt to decrypt a file
  ChangeFileOwnerFailed = 'ChangeFileOwnerFailed', // Failed attempt to change the owner of a file
  SetFileExpirationFailed = 'SetFileExpirationFailed', // Failed attempt to set an expiration date
  GenerateShareLinkFailed = 'GenerateShareLinkFailed', // Failed attempt to generate a share link
  ValidateUserFailed = 'ValidateUserFailed', // Failed attempt to validate a user
  SignFileFailed = 'SignFileFailed', // Failed attempt to sign a file with digital signature
  FileDescriptionFailed = 'FileDescriptionFailed', // Failed attempt to setting file Description
  ShortCutFailed = 'ShortCutFailed', // Failed attempt to create file short cut

  // Security and Monitoring
  ScreenCaptureAttempt = 'ScreenCaptureAttempt', // Attempt to capture the screen
  ClipboardCopyAttempt = 'ClipboardCopyAttempt', // Attempt to copy to clipboard
  UnauthorizedAccessAttempt = 'UnauthorizedAccessAttempt', // Unauthorized access attempt
  ScreenCaptureAttemptFailed = 'ScreenCaptureAttemptFailed', // Failed attempt to capture the screen
  ClipboardCopyAttemptFailed = 'ClipboardCopyAttemptFailed', // Failed attempt to copy to clipboard
  UnauthorizedAccessAttemptFailed = 'UnauthorizedAccessAttemptFailed', // Failed unauthorized access attempt
  MalwareDetection = 'MalwareDetection', // Detection of malware
  MalwareRemoval = 'MalwareRemoval', // Removal of detected malware
  SuspiciousActivityDetected = 'SuspiciousActivityDetected', // Detection of suspicious activity
  IntrusionDetection = 'IntrusionDetection', // Detection of an intrusion attempt
  IntrusionPrevention = 'IntrusionPrevention', // Prevention of an intrusion attempt
  DataLeakageAttempt = 'DataLeakageAttempt', // Attempt to leak data
  DataLeakageAttemptFailed = 'DataLeakageAttemptFailed', // Failed attempt to leak data
  PhishingAttemptDetected = 'PhishingAttemptDetected', // Detection of a phishing attempt
  RansomwareAttackDetected = 'RansomwareAttackDetected', // Detection of a ransomware attack
  BruteForceAttackDetected = 'BruteForceAttackDetected', // Detection of a brute force attack
  TwoFactorAuthEnabled = 'TwoFactorAuthEnabled', // Enabling two-factor authentication
  TwoFactorAuthDisabled = 'TwoFactorAuthDisabled', // Disabling two-factor authentication
  TwoFactorAuthAttemptFailed = 'TwoFactorAuthAttemptFailed', // Failed attempt for two-factor authentication
  PasswordChange = 'PasswordChange', // Changing a password
  PasswordChangeFailed = 'PasswordChangeFailed', // Failed attempt to change a password
  SecuritySettingsUpdate = 'SecuritySettingsUpdate', // Updating security settings
  SecuritySettingsUpdateFailed = 'SecuritySettingsUpdateFailed', // Failed attempt to update security settings
  FirewallRuleChange = 'FirewallRuleChange', // Changing a firewall rule
  FirewallRuleChangeFailed = 'FirewallRuleChangeFailed', // Failed attempt to change a firewall rule
  EncryptionKeyManagement = 'EncryptionKeyManagement', // Managing encryption keys
  EncryptionKeyManagementFailed = 'EncryptionKeyManagementFailed', // Failed attempt to manage encryption keys
  AccessControlPolicyChange = 'AccessControlPolicyChange', // Changing access control policies
  AccessControlPolicyChangeFailed = 'AccessControlPolicyChangeFailed', // Failed attempt to change access control policies
  SecurityPatchApplied = 'SecurityPatchApplied', // Applying a security patch
  SecurityPatchAppliedFailed = 'SecurityPatchAppliedFailed', // Failed attempt to apply a security patch
}
